import { apiClient } from './apiClient';

export interface NotificationItem {
  id: number;
  type: string;
  title: string;
  message: string | null;
  related_project_id: number | null;
  read: boolean;
  created_at: string;
}

export interface NotificationListResponse {
  data: NotificationItem[];
  unread_count: number;
}

const notificationService = {
  list: async (page = 1, pageSize = 20): Promise<NotificationListResponse> => {
    const response = await apiClient.get<NotificationListResponse>('notifications', {
      page,
      page_size: pageSize,
    });
    return response.data;
  },

  markRead: async (id: number): Promise<void> => {
    await apiClient.patch(`notifications/${id}/read`);
  },

  markAllRead: async (): Promise<void> => {
    await apiClient.patch('notifications/mark-all-read');
  },
};

export default notificationService;
